module.exports = __webpack_public_path__ + "img/pt_bd.1d9ded97.png";